// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1Cx-e","buttons":"SendReceipts_buttons__2WkXZ","email":"SendReceipts_email___Pr_V","bookApptTitle":"SendReceipts_bookApptTitle__1MrG7"};